export default {
	apiKey: "AIzaSyAzeNgxNSHxjwDdvUt5BClVKbYCZypK8vI",
    authDomain: "photobook-1337.firebaseapp.com",
    databaseURL: "https://photobook-1337.firebaseio.com",
    projectId: "photobook-1337",
    storageBucket: "gs://photobook-1337.appspot.com/",
    messagingSenderId: "356673081408"
}


//////////////////
// WEBPACK FOOTER
// ./firebase/firebaseConfig.js
// module id = null
// module chunks = 